module.exports = __webpack_public_path__ + "img/exhibition1.6b64b86a.png";